import { useState, useEffect } from "react";
import { notification } from "antd";

import {
  AssessmentTemplateHttpService,
  GetAssessmentTemplatesParameters,
  IAssessmentTemplateListItem,
} from "@/modules/assessments/services/assessment-template-http.service";
import { getFriendlyErrorMessage } from "@/shared/services/http";

export function useGetAssessmentTemplatesHook({ take, skip, search }: GetAssessmentTemplatesParameters = {}) {
  const [templates, setTemplates] = useState<IAssessmentTemplateListItem[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchTemplates() {
      try {
        const { data, totalCount } = await AssessmentTemplateHttpService.getAssessmentTemplates({
          take,
          skip,
          search,
        });
        setTemplates(data);
        setTotalCount(totalCount);
      } catch (error) {
        const message = getFriendlyErrorMessage(error) ?? "Failed to load assessment templates. Please try again.";
        notification.error({ message });
      } finally {
        setIsLoading(false);
      }
    }

    fetchTemplates();
  }, [take, skip, search]);

  return { templates, totalCount, isLoading };
}
